import React, { Component, PropTypes } from 'react';
import './Jigglypuff.scss';

class Jigglypuff extends Component {
  render() {
    return (
      <div className="pokemon">
        <div className="jigglypuff">
          <div className="head">

          </div>
          <div className="body">

          </div>
        </div>
      </div>
    );
  }
}

export default Jigglypuff;



/** WEBPACK FOOTER **
 ** ./source/039-jigglypuff/Jigglypuff.js
 **/